import React from "react";
import { useStyles } from "./styles";

interface SliderProps {
  min: number;
  max: number;
  value: number;
  step: number;
  onChange: (value: number) => void;
}

export const Slider = ({ max, min, step, value, onChange }: SliderProps) => {
  const classes = useStyles();

  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;

    const min = Number(target.min);
    const max = Number(target.max);
    const value = Number(target.value);

    const percentage = ((value - min) * 100) / (max - min);
    target.style.backgroundSize = `${percentage}% 100%`;

    onChange(value);
  };

  return (
    <input
      type="range"
      className={classes.input}
      max={max}
      min={min}
      step={step}
      value={value}
      onChange={changeHandler}
    />
  );
};
